module.exports = __webpack_public_path__ + "static/media/one-menu-thumbnail.0ed21b80.png";